/**
通用按钮类：noticeCreate-vmodel.js
通用工具类：JsFormDB.js

一、StorageData：封装

1. 验证项目名称填写，2718-2735

2. 获取表格数据(TCIDS_MUT)，2740-2788

3. 获取(input,textarea,select)数据，2791-2816

4. 获取(input,textarea,select)隐藏数据，2818-2829

5. 保证金字段(margin_amount)验证，2841-2859

6. 获取(radio,checkbox,ueditor,container)数据并验证，2860-2929
   container 表示附件上传

7. 设置招标编号(PROJECT_CODE)，2932-2936

8. 招标项目类型(TENDER_PROJECT_TYPE)，2938-2945

9. 设置字段(PROJECT_ID,SYS_CODE,REGION_CODE,BEIANDIQU_CODE)，2949-2956

10. 设置保证金缴纳方式(MARGIN_SUBMIT_TYPE)，2959-3040

11. 显示保函信息补充字段模块

二、获取评标委员会人数(ALL_EXPERT_NUM)所属TCID => ALL_EXPERT_NUM_TCID，484-494

三、验证评标委员会人数(ALL_EXPERT_NUM)，502-510

四、E1，E2字段验证，515-532

五、标段(t1852_dataList)字段特殊处理，545-587

六、暂存，591

七、更新按钮，634-683

八、刷新电子保函补充字段，688
*/
/**
1. 验证电子保函补充字段，3514-3521

2. 保证金金额验证（margin_amount），3532-3539

3. 招标人编码验证（t1851_TENDER_CODE），3540-3550

4. 获取(input,textarea,select)数据，3527-3623

5. 
*/
export const SiteBookingUtils = {
  firstValue: '',
  host: '',
  msg: '',
  validRes: null,
  stateOptions: {
    3: '取消',
    4: '退回',
    5: '使用',
    6: '临时预约',
  },
  getHost() {
    return new Promise((resolve, reject) => {
      if(this.host) {
        resolve()
      } else {
        api.get('/static/config/siteBookingServelUrl.json').then(res => {
          this.host = res.siteBookingServelUrl
          resolve()
        }).catch(e => null)
      }
    })
  },
  valid(form, callback) {
    let value = form.t1851_SITE_BOOKING_NUM
    let {firstValue, msg} = this
    if(firstValue === value) {
      msg ? callback(new Error(msg)) : callback()
      setTimeout(() => {
        store.dispatch('calcTenderCount')
      }, 100)
    } else {
      this.firstValue = value
      if(value) {
        this.remoteValid(form, callback)
      } else {
        this.msg = ' '
        callback(new Error(this.msg))
      }
    }
  },
  remoteValid(form, callback) {
    let {stateOptions} = this
    let value = form.t1851_OPEN_BID_SITE
    let res = this.validRes
    if(res) {
      if(res.status === -1) return callback(new Error(res.msg))
      let {fetchCenterInfoStatus, state, centerData} = res.order
      if (fetchCenterInfoStatus && state == 200) {
        if(centerData.id === value) {
          let extraData = JSON.parse(centerData.extraData)
          form.t1858_BID_OPEN_PLACE = extraData.Address
          this.msg = ''
          callback()
        } else {
          this.msg = '该编号与开标场地不匹配，请重新填写'
          callback(new Error(this.msg))
        }
      } else {
        state = stateOptions[state] || '审核中'
        ElMessageBox({
          title: "数据验证",
          closeOnClickModal: false,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "确定",
          message: h("p", { style: "font-weight:bolder" }, [
            h("span", null, "当前预约订单状态为"),
            h("span", { style: "color: red" }, state),
            h("span", null, "状态，不可使用，请重新输入订单状态为"),
            h("span", { style: "color: red" }, "预约成功"),
            h("span", null, "的场地预约编号！"),
          ]),
        }).then(() => {
          ElMessage.warning("请填写有效的场地预约编号！");
        }).catch(e => null)
        this.msg = '请填写有效的场地预约编号！'
        callback(new Error(this.msg));
      }
    } else {
      callback()
    }
  },
  newValid(form) {
    let value = form.t1851_SITE_BOOKING_NUM
    if(!value) return false
    api.get(`/JTHandler/ProjectAgentHandler.ashx`, {
      OPTYPE: 'ExistValidOrder',
      orderid: value,
      r: Math.random()
    }).then(res => {
      this.validRes = res
      store.dispatch('setValidatorCount')
    }).catch(e => null)
  }
}

export const MarginUtils = {
  noText: '①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳',
  initOptions(form, baseInfo) {
    let options =[{  Name: "现金",Value: "0" },{  Name: "银行保函",Value: "1" },{  Name: "年度投标保证金",Value: "2" },{  Name: "工程担保公司出具的担保保函",Value: "4" },{  Name: "保险公司出具的投标保证保险",Value: "5" }];
    switch(baseInfo.TYPE) {
      //9施工10国省道施工15勘察设计16施工监理
      case '9':
      case '10':      
      case '15':
      case '16':     
        options = [{  Name: "现金",Value: "0" },{  Name: "银行保函",Value: "1" },{  Name: "年度投标保证金",Value: "2" },{  Name: "工程担保公司出具的担保保函",Value: "4" },{  Name: "保险公司出具的投标保证保险",Value: "5" }];
        break; 
    }
    // if(form.regionId.indexOf('x') === 0) {
    //   options = options.filter(x => x!== '年度投标保证金')
    // }
    return options.map(x => ({
      Name: x.Name, Value: x.Name
    }))
  },
  initNoOptions(form) {
    let options =  []
    switch(form.type) {
      case '施工':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', 
          '年度投标保证金形式', '免缴投标保证金形式', '其他形式'
        ]
        break;
      case '监理':
        options = [
          '现金形式', '银行保函形式', '年度投标保证金形式', 
          '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式'
        ]
        break;
      case '勘察':
      case '建筑设计':
      case '市政设计':
      case '园林绿化':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', 
          '福建省建筑业龙头企业年度投标保证金形式', '年度投标保证金形式'
        ]
        break;
      case '工程总承包':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', '年度投标保证金形式'
        ]
        break;
    }
    options = options.map((x, i) => ({
      Name: `${this.noText[i]}${x}`, Value: i + 1
    }))
    // if(form.regionId.indexOf('x') === 0) {
    //   options = options.filter(x => x.Name.indexOf('年度投标保证金形式') !== 1)
    // }
    return options
  },
  getMarginPayTypeValue(form) {
    return form.t1871_MARGIN_SUBMIT_TYPE || form.t1873_MARGIN_SUBMIT_TYPE || form.t1913_MARGIN_SUBMIT_TYPE || form.t1911_MARGIN_SUBMIT_TYPE || form.t1957_MARGIN_SUBMIT_TYPE
  },
  loadFilterWithText (MARGIN_SUBMIT_TYPE) {
    const marginPayType = []
    MARGIN_SUBMIT_TYPE&&MARGIN_SUBMIT_TYPE.split(',').forEach(type => {
      switch (type) {
        case '0': marginPayType.push('现金'); break;
        case '1': marginPayType.push('银行保函'); break;
        case '2': marginPayType.push('年度投标保证金'); break;
        case '4': marginPayType.push('工程担保公司出具的担保保函'); break;
        case '5': marginPayType.push('保险公司出具的投标保证保险'); break;
        case '6': marginPayType.push('其他'); break;
        default: break;
      }
    })
    return marginPayType
  },
  getMarginSubmitType (MARGIN_PAY_TYPE) {
    const marginSubmitType = []
    MARGIN_PAY_TYPE.forEach(type => {
      switch (type) {
        case '现金': marginSubmitType.push('0'); break;
        case '银行保函': marginSubmitType.push('1'); break;
        case '年度投标保证金': marginSubmitType.push('2'); break;
        case '工程担保公司出具的担保保函': marginSubmitType.push('4'); break;
        case '保险公司出具的投标保证保险': marginSubmitType.push('5'); break;
        case '其他': marginSubmitType.push('6'); break;
        default: break;
      }
    })
    return marginSubmitType.join(',')
  }
}

export const TrafficUtils = {
  initBondInfo (form) {
    form.isBondOnline = form.isHasBond = HouseState.BZJ_ADDRESS.indexOf(form.region) >= 0
  },
  changeAreaRadio(form, regions) { // 场内标选择交易中心
    form.isHasBond = HouseState.BZJ_ADDRESS.indexOf(form.areaRadio) >= 0
    form.isBondOnline = form.BOND_BANKS_SELECT.reduce((pre, cur) => {
      return pre && HouseState.CUSTOM_BANK_ACCOUNT.indexOf(cur) === -1
    }, form.isHasBond)

    if(!form.isHasBond) form.BOND_BANKS_SELECT = []

    form.OPENING_BANK = ''
    form.ACCOUNT_NAME = ''
    form.ACCOUNT_NUMBER = ''
    form.BOND_BANKS = []
    form.BOND_BANKS_SELECT = []

    if(form.regionId === 'x60005') {
      form.TRADE_CENTER = {Value: 'x60005', Name: '福清市'}
    } else {
      console.log(regions)
    }
  },
  changeBondBanks(form) { // 保证金银行选择
    form.isBondOnline = true
    let xIndex = form.BOND_BANKS_SELECT.reduce((pre, cur, index) => {
      return HouseState.CUSTOM_BANK_ACCOUNT.indexOf(cur) >= 0 ? index : pre
    }, -1)
    if(xIndex === form.BOND_BANKS_SELECT.length - 1) {
      form.isBondOnline = false
      if(xIndex > 0) form.BOND_BANKS_SELECT.splice(0, form.BOND_BANKS_SELECT.length - 1)
    } else if(xIndex >= 0) {
      form.BOND_BANKS_SELECT.splice(xIndex, 1)
    }
  },
  isInBzjAddress(form) {
    return new Promise((resolve, reject) => {
      if(HouseState.BZJ_ADDRESS.indexOf(form.region) >= 0) {
        resolve()
      } else {
        reject()
      }
    })
  },
  setReportCtbaName(form, CreatedBy) {
    if(form.IS_REPORT_CTBA_NAME === undefined) {
      form.IS_REPORT_CTBA_NAME = CreatedBy.UserName
    }
  },
  resetBondBanks(form, {state, config, isOnlySet}) {
    if(form.BOND_BANKS_SELECT.length) {
      HouseUtils.changeBondBanks(form)
    }
    if(form.isBondOnline && !isOnlySet) {
      form.BOND_BANKS_SELECT.forEach(value => {
        state.selections.bankOptions.forEach(obj => {
          if(obj.NAME === value) {
            if(['勘察', '建筑设计', '市政设计'].indexOf(form.type) >= 0) {
              form.MARGIN_BANK = form.MARGIN_BANK ? `${form.MARGIN_BANK}，${obj.NAME}` : obj.NAME
              form.MARGIN_NAME = form.MARGIN_NAME ? `${form.MARGIN_NAME}，${obj.MAIN_NAME}` : obj.MAIN_NAME
              form.MARGIN_NUMBER = '在线获取保证金子账号'         
            } else {
              form.OPENING_BANK = form.OPENING_BANK ? `${form.OPENING_BANK}，${obj.NAME}` : obj.NAME
              form.ACCOUNT_NAME = form.ACCOUNT_NAME ? `${form.ACCOUNT_NAME}，${obj.MAIN_NAME}` : obj.MAIN_NAME
              form.ACCOUNT_NUMBER = '在线获取保证金子账号'              
            }
            form.BOND_BANKS.push(obj)
          }
        }) 
      })
    }
    let disabled = form.BOND_BANKS_SELECT[0] !== '其他账户'
    if(['勘察', '建筑设计', '市政设计'].indexOf(form.type) >= 0) {
      config['/1/section-02'].MARGIN_BANK.Disabled = disabled
      config['/1/section-02'].MARGIN_NAME.Disabled = disabled
      config['/1/section-02'].MARGIN_NUMBER.Disabled = disabled

      config['/2/section-02'].MARGIN_BANK.Disabled = disabled
      config['/2/section-02'].MARGIN_NAME.Disabled = disabled
      config['/2/section-02'].MARGIN_NUMBER.Disabled = disabled  
      return false
    }
    if(form.type === '监理') {
      config['/7/section-01'].OPENING_BANK.Disabled = disabled
      config['/7/section-01'].ACCOUNT_NAME.Disabled = disabled
      config['/7/section-01'].ACCOUNT_NUMBER.Disabled = disabled  
    } else {
      config['/9/section-01'].OPENING_BANK.Disabled = disabled
      config['/9/section-01'].ACCOUNT_NAME.Disabled = disabled
      config['/9/section-01'].ACCOUNT_NUMBER.Disabled = disabled  
    }

    config['/2/section-02'].OPENING_BANK.Disabled = disabled
    config['/2/section-02'].ACCOUNT_NAME.Disabled = disabled
    config['/2/section-02'].ACCOUNT_NUMBER.Disabled = disabled  
  },
  getDefaultMargins(form) {
    let defaultMargins = []
    switch(form.regionId) {
      case '350722': // 浦城
      case '350723': // 光泽
      case '350724': // 松溪
      case '350725': // 政和
      case '350783': // 建瓯
        defaultMargins = [
          '银行保函', 
          '保险公司出具的投标保证保险', 
          '工程担保公司出具的担保保函'
        ]
        break;
      default:
        defaultMargins = []
        break;
    }
    return defaultMargins
  },
  getMarginPayTypeForPc(form) {
    let res = ['现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', '年度投标保证金']
    let {MARGIN_PAY_TYPE} = form
    if(MARGIN_PAY_TYPE.indexOf('福建省建筑业龙头企业年度投标保证金形式') >= 0) {
      res.push('福建省建筑业龙头企业年度投标保证金形式')
    }
    return res.reduce((pre, cur) => [...pre, {Name: cur, Value: cur}], [])
  },
  resetNoticeMedia(form) {
    let TENDER_PLATFORMS = get_TENDER_PLATFORMS()
    let { regionId, REGION_CODE, isReportedFujianProvinceProperty } = form
    if(regionId === 'x00004') {
      if(/^35\d{4}$/.test(REGION_CODE) && isReportedFujianProvinceProperty) {
        form.NOTICE_MEDIA3 = `${TENDER_PLATFORMS.GGFW}、${TENDER_PLATFORMS.DZJY}${TENDER_PLATFORMS.GZCG}`
      } else {
        form.NOTICE_MEDIA3 = `${TENDER_PLATFORMS.GGFW}、${TENDER_PLATFORMS.DZJY}`
      }
    }
  }
}

export const loadFilterFiles =  (json, config) => {
  const { FILE_KEYS } = config
  FILE_KEYS.forEach(key => {
    json[key] = json[key.replace(/^(t\d+)_(.+)$/, `$1_UPLOAD_$2`)] || []
  })
  return json
}

const buildGuaranteeData = (form, baseInfo) => {
  const formText = {
    APPROVAL_NUMBER: form.t1850_APPROVAL_NUMBER, //项目审批文号
    BEIANDIQU_CODE: baseInfo.SITE === 1 ? baseInfo.AREACODE : form.t1851_REGION_CODE, // 备案地区编号
    BULID_PLACE: form.t1850_ADDRESS, // 建筑地址
    LEGAL_PERSON_CODE: form.t1851_TENDERER_CODE, //招标人社会统一信用代码
    PROJECT_FILE_CODE: "", //立项文件号
    PROJECT_ID: form.t1851_TENDER_PROJECT_CODE, // 项目ID
    PROJECT_NAME: form.t1851_TENDER_PROJECT_NAME, // 项目名称
    PROJECT_CODE: form.t1851_PROJECT_CODE, // 项目编号
    REGION_CODE: form.t1851_REGION_CODE, // 地区编码
    SYS_CODE: '3', // 系统编号
    TENDERER_LEGAL_UNIT_ADDRESS: form.t1851_TENDERER_LEGAL_UNIT_ADDRESS, //招标人详细地址
    TENDERER_LEGAL_CONTACT: form.t1851_TENDERER_LEGAL_CONTACT, //招标联系人名称
    TENDERER_LEGAL_CONTACT_PHONE: form.t1851_TENDERER_LEGAL_CONTACT_PHONE, //招标人联系电话
    TENDERER_NAME: form.t1851_TENDERER_NAME, //招标企业名称
    TENDER_PROJECT_CODE: form.t1851_TENDER_PROJECT_CODE, // 招标项目编号
    TENDER_PROJECT_TYPE: form.t1851_TENDER_PROJECT_TYPE === 'A03' ? '公路' : '水运' // 招标项目类型
  }
  const MARGIN_SUBMIT_TYPE = MarginUtils.getMarginPayTypeValue(form)

  if (MARGIN_SUBMIT_TYPE) {
    formText.MARGIN_PAY_TYPE = MarginUtils.loadFilterWithText(MARGIN_SUBMIT_TYPE)
    const bidDataList = form.t1852_dataList
    if (bidDataList && bidDataList.length) {
      const { t1852_BID_SECTION_CODE, t1852_BID_SECTION_NAME, t1852_MARGIN_AMOUNT, t1852_LIMITE_TIME, t1852_BID_BUDGET_AMOUNT } = bidDataList[0]
      formText.BID_SECTION_CODE = t1852_BID_SECTION_CODE
      formText.BID_SECTION_NAME = t1852_BID_SECTION_NAME
      formText.MARGIN_AMOUNT = t1852_MARGIN_AMOUNT * 1e4
      formText.PLAN_DATE = t1852_LIMITE_TIME
      formText.CONTRACT_RECKON_PRICE = t1852_BID_BUDGET_AMOUNT
    }
    const VALID_PERIOD1 = form.t1871_TENDER_VALIDITY_PERIOD
    const VALID_PERIOD2 = form.t1913_BID_LIMIT_TIME
    const VALID_PERIOD3 = form.t1873_TENDER_VALIDITY_PERIOD
    const VALID_PERIOD4 = form.t1858_VALID_PERIOD
    
    formText.VALID_PERIOD = VALID_PERIOD4 || VALID_PERIOD3 || VALID_PERIOD2 || VALID_PERIOD1 || ''
  }

  return formText
}

const getTemplateAndVersion = (baseInfo) => {
  let template = "";
  let version = "2018";
  switch (baseInfo.TYPE) {
    case 1:
      template = "高速公路-路基土建施工";
      break;
    case 2:
      template = "高速公路-路面土建施工";
      break;
    case 3:
      template = "高速公路-勘察设计";
      break;
    case 4:
      template = "高速公路-勘察监理、设计审查";
      break;
    case 5:
      template = "高速公路-土建工程施工监理";
      break;
    case 6:
      template = "高速公路-试验检测";
      break;
    case 7:
      template = "高速公路-机电施工";
      break;
    case 8:
      template = "高速公路-机电工程施工监理";
      break;
    case 9:
      template = "普通公路-公路施工";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_PTGL_SG_CWB : baseInfo.ZBGG_PAGE_VERSION_PTGL_SG;
      break;
    case 10:
      template = "普通公路-国省道施工";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_PTGL_GSDYHSG_CWB : baseInfo.ZBGG_PAGE_VERSION_PTGL_GSDYHSG;
      break;
    case 11:
      template = "水运工程-施工";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_GH_SG_CWB : baseInfo.ZBGG_PAGE_VERSION_GH_SG;
      break;
    case 12:
      template = "水运工程-勘察设计";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_GH_KCSJ_CWB : baseInfo.ZBGG_PAGE_VERSION_GH_KCSJ;
      break;
    case 13:
      template = "水运工程-施工监理";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_GH_SGJL_CWB : baseInfo.ZBGG_PAGE_VERSION_GH_SGJL;
      break;
    case 14:
      template = "水运工程-试验检测文件";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_GH_SYJC_CWB : baseInfo.ZBGG_PAGE_VERSION_GH_SYJC;
      break;
    case 15:
      template = "普通公路-勘察设计";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_PTGL_KCSJ_CWB : baseInfo.ZBGG_PAGE_VERSION_PTGL_KCSJ;
      break;
    case 16:
      template = "普通公路-施工监理";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_PTGL_SGJL_CWB : baseInfo.ZBGG_PAGE_VERSION_PTGL_SGJL;
      break;
    case 17:
      template = "普通公路-国省道施工监理";
      version = baseInfo.SITE == "1" ? baseInfo.ZBGG_PAGE_VERSION_PTGL_GSDYHSGJL_CWB : baseInfo.ZBGG_PAGE_VERSION_PTGL_GSDYHSGJL;
      break;
    default:
      break;
  }
  switch (baseInfo.EVALUATION_METHOD) {
    case 1:
      template += "-综合评估法";
      break;
    case 11:
      template += "-综合评估法I";
      break;
    case 12:
      template += "-综合评估法II";
      break;
    case 2:
      template += "-合理低价法";
      break;
    case 21:
      template += "-合理低价法（含信用分）";
      break;
    case 3:
      template += "-固定价随机抽取中标人";
      break;
    default:
      break;
  }
  // if (baseInfo.TENDER_MODE && baseInfo.TENDER_MODE.toString() === "2") {
  //   template += "-邀请"
  // }
  template += "-标段"
  if (version === "" || version === undefined) {
    version = baseInfo.SITE === "1" ? "cwb_191209" : "2018"
  }
  return {
    template,
    version
  }
};

export const TenderCheckedUtils = {
  $vm: null,
  state: {
    modify: false,
    price: '',
    priceTemp: '',
    area: '',
    areaTemp: '',
    actions: [],
    message: '',
    form: {}
  },
  setArea(area) {
    let { state } = this
    state.area = area
    this.checkModify()
  },
  checkModify() {
    let { price, priceTemp, area, areaTemp } = this.state
    this.state.modify = !(price === priceTemp && area === areaTemp)
    this.$vm.checkedModify = this.state.modify
    // this.disabledPublish()
  },
}
export default {
  buildGuaranteeData,
  getTemplateAndVersion
}